import * as z from "zod";

export const ProductCodeSchema = z.enum(["chargebacks"]);

export type ProductCode = z.infer<typeof ProductCodeSchema>;

export const ReferrerInstallSchema = z.object({
  id: z.string(),
  shopName: z.string(),
  shopDomain: z.string(),
  productCode: ProductCodeSchema,
  installedAt: z.iso.datetime(),
});

export type ReferrerInstall = z.infer<typeof ReferrerInstallSchema>;
